import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import EnergySummaryCards from "../../components/EnergySummaryCards";
import WeeklyEnergyChart from "../../components/WeeklyEnergyChart";
import WeeklyReactiveEnergyChart from "../../components/WeeklyReactiveEnergyChart";

import ActiveEnergyPie from "../../components/ActiveEnergyPie"
import ReactiveEnergyPie from "../../components/ReactiveEnergyPie"

import PhaseApparentEnergyBars from "../../components/PhaseApparentEnergyBars";
import PhaseActiveEnergyBars from "../../components/PhaseActiveEnergyBars";
import PhaseReactiveEnergyBars from "../../components/PhaseReactiveEnergyBars";


import EnergiesReportDialog from "../../components/EnergiesReportDialog";
import EnergyCompareDialog from "../../components/EnergyCompareDialog";
import ConsumptionCalculatorDialog from "../../components/ConsumptionCalculatorDialog";

export default function AnalyzerEnergyDashboard() {
    const { t } = useTranslation();
    const { deviceId } = useParams();
    const API_BASE = process.env.REACT_APP_API_BASE_URL;

    const [summary, setSummary] = useState({});

    const [reportOpen, setReportOpen] = useState(false);
    const [compareOpen, setCompareOpen] = useState(false);
    const [calcOpen, setCalcOpen] = useState(false);


    useEffect(() => {
        fetch(`${API_BASE}/measurements/energy-summary?deviceId=${deviceId}`)
            .then(res => res.json())
            .then(data => setSummary(data))
    }, [deviceId]);




    return (
        <div className="p-6 space-y-10">
            {/* Rapor butonları */}
            <div className="flex justify-end gap-3 mt-2">
                <button
                    onClick={() => setReportOpen(true)}
                    className="bg-sky-600 text-white px-4 py-2 rounded-md hover:bg-sky-700"
                >
                    {t('energies.reportDownload')}
                </button>

                <button
                    onClick={() => setCompareOpen(true)}
                    className="bg-emerald-600 text-white px-4 py-2 rounded-md hover:bg-emerald-700"
                >
                    {t('energies.compareReport')}
                </button>

                <button
                    onClick={() => setCalcOpen(true)}
                    className="bg-orange-600 text-white px-4 py-2 rounded-md hover:bg-orange-700"
                >
                    {t('consumptionCalculator.dashboardButton')}
                </button>
            </div>


            {/* Özet Kartlar */}
            {summary && <EnergySummaryCards data={summary} />}

            {/* Haftalık 7 Günlük Aktif & Reaktif */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                <WeeklyEnergyChart deviceId={deviceId} API_BASE={API_BASE} />
                <WeeklyReactiveEnergyChart deviceId={deviceId} API_BASE={API_BASE} />
            </div>

            {/* Faz Bazlı Aktif – Reaktif – Görünür Enerji */}
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
                <PhaseActiveEnergyBars deviceId={deviceId} API_BASE={API_BASE} />
                <PhaseReactiveEnergyBars deviceId={deviceId} API_BASE={API_BASE} />
                <PhaseApparentEnergyBars deviceId={deviceId} API_BASE={API_BASE} />
            </div>


            {/* Aktif & Reaktif Enerji Pie Chartları */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                <ActiveEnergyPie
                    importVal={(summary.PT_IMPORT ?? 0) / 1000}
                    exportVal={(summary.PT_EXPORT ?? 0) / 1000}
                />

                <ReactiveEnergyPie
                    importVal={(summary.QT_IMPORT ?? 0) / 1000}
                    exportVal={(summary.QT_EXPORT ?? 0) / 1000}
                />

            </div>


            <EnergiesReportDialog
                open={reportOpen}
                onClose={() => setReportOpen(false)}
                deviceId={deviceId}
                deviceType="analyzer"
                API_BASE={API_BASE}
            />

            <EnergyCompareDialog
                open={compareOpen}
                onClose={() => setCompareOpen(false)}
                API_BASE={API_BASE}
                currentDeviceId={deviceId}
            />

            <ConsumptionCalculatorDialog
                open={calcOpen}
                onClose={() => setCalcOpen(false)}
                deviceId={deviceId}
                API_BASE={API_BASE}
            />


        </div>


    );
}
